<template>
  <div class="currentShowings" v-if="listingsWithActiveShowing">
    <HeaderNavigation title="visningar"/>
    <div class="container pt-75">
      <button class="width-100 outline mb-15" @click="$router.push('/visningar/ny-visning')">ny visning</button>
      <div v-for="listing in listingsWithActiveShowing" v-bind:key="listing.id" class="listing-list mb-5 shadow">
        <router-link :to="{ name: 'singleshowingobject', params: listing }">
          <div class="listing-image-wrap flex justify-center mr-15">
            <img class="listing-list__image" :src="listing.thumbnail">
          </div>
          <div class="listing-data">
            <div>
              <h3 class="bold mb-5">{{ listing.address }}</h3>
              <p class="listing-list__price">{{ listing.date }}</p>
              <p class="fs-15">{{ listing.time }}</p>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <Footer/>
  </div>
  <div v-else>
    <spinner/>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import HeaderNavigation from '../../components/HeaderNavigation';
import spinner from '../../components/spinner';

export default {
  name: 'CurrentShowings',
  computed: {
    listingsWithActiveShowing() {
      return this.$store.getters["showing/getListingsWithActiveShowing"];
    }
  },
  methods: {
    formatPrice(price) {
      return this.$root.formatPrice(price);
    }
  },
  created() {
    // Get all listings with active showing
    this.$store.dispatch('showing/storeAllListingsWithActiveShowing', true);
  },
  components: {
    Footer,
    HeaderNavigation,
    spinner
  },
}
</script>

<style>
.listing-list a {
  display: flex;
  padding: 15px;
  width: 100%;
  position: relative;
  background-color: #fff;
}
.listing-image-wrap {
  overflow: hidden;
  width: 75px;
  height: 65px;
}
.listing-image-wrap img {
  object-fit: cover;
  height: 100%;
}

</style>
